import type { Theme } from 'theme-ui';

export const theme: Theme = {
  colors: {
    red: '#740429',
    grey: '#e4e4e4',
  },
};
